/**
 * <p>****************************************************************************</p>
 * <p><b>Copyright © 2010-2019 soho team All Rights Reserved<b></p>
 * <ul style="margin:15px;">
 * <li>Description : </li>
 * <li>Version     : 1.0</li>
 * <li>Creation    : 2019年08月25日</li>
 * <li>@author     : ____′↘夏悸</li>
 * </ul>
 * <p>****************************************************************************</p>
 */
import Ajax from '../js/common/ajax';

export default {
	template: {
		list(params = {}) {
			return Ajax.get("/report/template", params)
		},
		load(id) {
			return Ajax.get(`/report/template/${id}`)
		},
		delete(id) {
			return Ajax.delete(`/report/template/${id}`)
		},
		save(params = {}) {
			return Ajax.post(`/report/template`, params)
		},
		update(params = {}) {
			return Ajax.put(`/report/template`, params)
		},
		items: {
			save(params = {}) {
				return Ajax.post(`/report/template/items`, params)
			},
			update(params = {}) {
				return Ajax.put(`/report/template/items`, params)
			},
			delete(id) {
				return Ajax.delete(`/report/template/items/${id}`)
			},
			formula(params) {
				return Ajax.post(`/report/template/items/formula`, params)
			}
		}
	},
	view(id, params = {}) {
		return Ajax.get(`/report/template/view/${id}`, params)
	},
	//季度报表数据
	viewQuarter(id, params = {}) {
		return Ajax.get(`/report/template/view-quarter/${id}`, params)
	},
	//费用明细表（年度，专业版报表）
	feeDetail(params = {}) {
		return Ajax.get(`/pro-report/fee-detail`, params)
	},
	//账龄分析表
	ageAnalysis(params = {}) {
		return Ajax.get('/pro-report/age-analysis', params)
	},
	//资产汇总表
	assetsSummary(params = {}) {
		return Ajax.get('/pro-report/assets-summary', params)
	},
	//折旧/摊销明细表
	assetsDepreciation(params = {}) {
		return Ajax.get('/pro-report/assets-depreciation', params)
	}
}